function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 -0.5 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    transform: "matrix(1.170513,0,0,1.083253,-4.2657152,2.1328851)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#434343",
    d: "M9.739 4.36H1.487v11.958h1.855l-.014.994h.892v-.994h5.566v.994h.892v-.994h1.855V4.36Z",
    style: {
      strokeWidth: 0.959424
    },
    transform: "matrix(1.0014489,0,0,1,5.6170037,-4.0490002)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.124.312h.984V12.27h-.984Z",
    style: {
      fill: "#000000",
      strokeWidth: 0.0185259
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.466 1.83h.661v8.875h-.66Z",
    style: {
      fill: "#4d4d4d",
      strokeWidth: 0.0493898
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.469-.16h12.699v.5h-12.7Z",
    style: {
      fill: "#000000",
      strokeWidth: 0.0566144
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStove);
export default __webpack_public_path__ + "static/media/stove.adc1e40cc2e20b3041f781ca46a1e772.svg";
export { ForwardRef as ReactComponent };